import React, { useState, useContext } from "react";
import { ReactComponent as Close } from "../../assets/icons/x.svg";
import axios from "axios";
import { NotificationContext } from "../../Context/NotificationContext";
import { Loader } from "react-feather";
import "./ForgotPasswordForm.css";
import { FormTextInput } from "../../Components/FormTextInput";
import { getFullHttpUrl } from "../../firebase.config";
import { EAST1, EAST4 } from "../../utility/enums";
import { useCheckoutT } from "../../i18n/checkout";

export default function ForgotPasswordForm({
  isLoginOpen,
  goToVerification,
  backToSignIn,
  email,
  setEmail,
}) {
  const [emailError, setEmailError] = useState(false);
  const { showNotification } = useContext(NotificationContext);
  const [isLoading, setIsLoading] = useState(false);
  // English everywhere but the checkout (see i18n/checkout).
  const { t } = useCheckoutT();
  // The button's text, by key (see i18n/checkout/strings/account.js).
  const [btnKey, setBtnKey] = useState("account.forgot.send");

  const closeForm = () => {
    isLoginOpen();
  };

  const verificationStart =async () => {
    if(email === "" || !/\S+@\S+\.\S+/.test(email)){
      setEmailError(true);
      return;
    }
    setBtnKey("account.forgot.sending");
    setIsLoading(true);
    
    try {
      axios.post(getFullHttpUrl("generateForgotPassCode", EAST4), {
        email: email.toLowerCase(),
      });
      goToVerification();
      showNotification(
        t("notify.success"),
        t("account.forgot.sent"),
        "success"
      );
    } catch (error) {
      // console.error(error);
      setIsLoading(false);
      setBtnKey("account.forgot.send");
      showNotification(
        t("notify.error"),
        t("account.codeSendError"),
        "error"
      );
      
    } finally {
      setIsLoading(false);
      setBtnKey("account.forgot.send");
    }
  };

  const handleEmailChange = (value) => {
    setEmail(value);
    setEmailError(false);
  }

    const triggerEnter = () => {
      if (!(email === "")) {
        verificationStart()
      }
    }
  
  // An empty field is only an error when sending (see SignInForm).
  const handleEmailBlur = () => {
    if (email !== "" && !/\S+@\S+\.\S+/.test(email)) {
      setEmailError(true);
    }
  };
  
  return (
    <div className="forgotPasswordForm">
      <div className="forgotPasswordFormHeader">
        <h2 className="forgotPasswordFormHeaderTitle">{t("account.forgot.title")}</h2>
        <Close className="signInFormIcon" onClick={closeForm} />
      </div>

      <span className="forgotPasswordFormText">
        {t("account.forgot.text")}
      </span>

      <div className="forgotPassworFormContainer">
        <FormTextInput email={true}  placeholder={t("field.email")} incorrect={emailError} clearInputIcon={true} value={email} onBlur={handleEmailBlur} onChange={handleEmailChange} onKeyDown={(e) => e.key === "Enter" && triggerEnter()}/>
      </div>

      {emailError ? (
        <span className="forgotPasswordFormError">
          {t("account.invalidEmailFormat")}
        </span>
      ) : null}
      <button
        className="forgotPasswordFormButton"
        disabled={email === "" || isLoading || emailError}
        onClick={() => verificationStart()}
      >
        {t(btnKey)}
        {isLoading && <Loader className="btnLoader"/>}
      </button>

      <span
        className="forgotPasswordFormBackToSignIn"
        onClick={() => backToSignIn()}
      >
        {t("account.backToSignIn")}
      </span>
    </div>
  );
}
